// extracted by mini-css-extract-plugin
export default {"statsWrapper":"Stats_statsWrapper__gptvO","stats":"Stats_stats__X9I+f","boldText":"Stats_boldText__06TSe","thinText":"Stats_thinText__3WPxA"};